import instance from '../../../../api/axios'
import {
  CreateLocation,
  Location,
  LocationListRequest,
  PaginatedLocationsResponse,
} from '../types/location'

export const loadLocations = async (): Promise<Location[]> => {
  const response = await instance.get('/locations')
  return response.data
}

export const loadLocationList = async (
  request: LocationListRequest,
): Promise<PaginatedLocationsResponse> => {
  const params: Record<string, string> = {
    page: String(request.page),
    limit: String(request.limit || 25),
  }

  if (request.name?.trim()) {
    params.name = request.name.trim()
  }

  const response = await instance.get('/locations/list', {
    params,
  })

  return response.data
}

export const loadLocation = async (id: string): Promise<Location> => {
  const response = await instance.get(`/locations/${id}`)
  return response.data
}

export const saveLocation = async (
  location: CreateLocation,
): Promise<Location> => {
  const response = await instance.post('/locations', location)
  return response.data
}

export const modifyLocation = async (location: Location): Promise<Location> => {
  const response = await instance.put('/locations', location)
  return response.data
}

export const removeLocation = async (id: string): Promise<string> => {
  const response = await instance.delete(`/locations/${id}`)
  return response.data
}
